<div class="row">
	<div class="col-sm-12">
		<div id="info-alert" class="m-alert m-alert--icon m-alert--outline alert {{colorClass? colorClass:'alert-info'}}" role="alert">
			<div class="m-alert__icon">
				<i class="la la-info-circle"></i>
			</div>
			<div class="m-alert__text">
				<strong>{{ infotTitle }}</strong>  {{ description }}	
			</div>
			<div class="m-alert__close">
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				</button>	
			</div>			  	
		</div>
	</div>
</div>